import { useMemo } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { RxChevronRight } from "react-icons/rx";
import Container from "../../../shared/Container";
import P from "../../../shared/typography/P";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";

import { LuBellRing } from "react-icons/lu";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { TbHandMove } from "react-icons/tb";
import { useHistory } from "react-router-dom";
import { ROLE } from "../../../constants/common";
import {
    ADMIN_MASTER_DATA,
    ADMIN_PAYMENT_CONFIRMATION_VIEW,
    ADMIN_REMINDER_VIEW,
} from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import { checkIsAllowed } from "../../../helpers/helpers";

const AdminMenu = ({ isOpen, onClick }) => {
    const history = useHistory();
    const { state } = useContextState();
    let isAdmin = checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN]);

    const moreMenuLinks = useMemo(() => {
        let links = [
            {
                id: 1,
                name: "View Reminders",
                icon: <LuBellRing />,
                link: ADMIN_REMINDER_VIEW,
            },
            {
                id: 2,
                name: "Payment Confirmation",
                icon: <MdOutlineCurrencyRupee />,
                link: ADMIN_PAYMENT_CONFIRMATION_VIEW,
            },
            // {
            //     id: 2,
            //     name: "View Tickets",
            //     icon: <LuTicketSlash />,
            //     link: TICKETS,
            // },
            // {
            //     id: 3,
            //     name: "View Project Status",
            //     icon: <GoProjectRoadmap />,
            //     link: ADMIN_PROJECT_STATUS,
            // },
        ];

        if (isAdmin) {
            links.push({
                id: 4,
                name: "Master Data",
                icon: <TbHandMove />,
                link: ADMIN_MASTER_DATA,
            });
        }
        return links;
    }, [isAdmin]);
    return (
        <BottomDrawer
            isOpen={isOpen}
            onClick={() => onClick(false)}
            showClose={false}
            contentClass="min-h-[60vh] rounded-t-4"
            childrenClassName="bg-white"
        >
            <div className="bg-violet-300  py-2 pb-5  ">
                <Container>
                    <button
                        type="button"
                        onClick={() => onClick(false)}
                        className="text-white text-base flex  items-center gap-0.5  font-vietnam"
                    >
                        <IoMdArrowBack /> Back
                    </button>
                </Container>
            </div>
            <div className="rounded-t-4 bg-white -mt-4 pb-7">
                <Container>
                    {moreMenuLinks.map((item) => (
                        <div
                            className="flex justify-between items-center gap-1 py-2.4 border-b border-blue-300"
                            key={item.id}
                            role="button"
                            onClick={() => {
                                onClick(false);
                                history.push(item.link);
                            }}
                        >
                            <div className="flex  items-center gap-1">
                                <div className="flex items-center justify-center h-3 w-3 rounded-full bg-blue-300 text-xxl">
                                    {item.icon}
                                </div>
                                <P className="text-sm font-vietnam text-secondary font-light">
                                    {item.name}
                                </P>
                            </div>

                            <RxChevronRight size={26} />
                        </div>
                    ))}
                </Container>
            </div>
        </BottomDrawer>
    );
};

export default AdminMenu;
